import DOMPurify from 'dompurify';
import session from './session';
import SpinnerGif from '../images/spinner.gif';
import cookiesManager from './browser-storage/cookies';
import { world } from '../languages';

type ExtraData = {
    noText?: boolean;
    canDownload?: boolean;
};

const downloading = (
    element: HTMLElement,
    materialId: number,
    cb?: (() => void) | null,
    extraData = {} as ExtraData
) => {
    if (world !== 'de') {
        return;
    }

    const list = [
        'Vorbereitung des Downloads...',
        'Komprimierung...',
        'Verpackung...',
        'Gleich geht`s los...',
        'Ein Kind, ein Lehrer, ein Stift und ein Buch können die Welt verändern. - Malala Yousafzai',
        'Es ist die wichtigste Kunst des Lehrers, die Freude am Schaffen und am Erkennen zu erwecken. - Albert Einstein',
        'Es erscheint immer unmöglich bis man es gemacht hat. - Nelson Mandela',
        'Ein Lehrer arbeitet für die Ewigkeit. Niemand kann sagen, wo sein Einfluss endet. - Henry Adams',
        'Um klar zu sehen, genügt oft ein Wechsel der Blickrichtung. - Antoine de Saint-Exupéry',
        'Erfolg hat drei Buchstaben: "Tun." - Goethe',
        'Wege entstehen dadurch, dass man sie geht. - Kafka',
        'Wir können den Wind nicht ändern, aber die Segel anders setzen. - Aristoteles',
        'Gebildet ist, wer weiß, wo er findet, was er nicht weiß. - Georg Simmel',
        'Kreativität ist Intelligenz, die Spaß hat. - Albert Einstein',
        'Die Hauptaufgabe des Lehrers ist es nicht, Bedeutungen zu erklären, sondern an die Tür des Geistes zu klopfen. - Rabindranath Tagore',
        'Das Geheimnis der Erziehungskunst die ist der Respekt vor dem Schüler. - Ralph Waldo Emerson',
        'Nur der ist ein geborener Lehrer, welcher die Begeisterung seiner Schüler erwecken kann. - Ernst Hähnel',
        'Du brauchst keinen Lehrer, der dich beeinflusst. Du brauchst einen Lehrer, der dich lehrt, dich nicht mehr beeinflussen zu lassen. - Dalai Lama',
        'Lernen und nicht denken ist nichtig. Denken und nicht lernen ist gefährlich. - Konfuzius',
        'Es ist die wichtigste Kunst des Lehrers, die Freude am Schaffen und am Erkennen zu erwecken. - Albert Einstein',
        'Schülersprüche: Beim Fußball bin ich Stürmer, in Mathe in der Abwehr',
        'Lehrersprüche: Ich sehe heute wieder viele, die nicht da sind',
        'Lehrersprüche: Hab keine Lust mehr, bin zaubern',
        'Wer mit seinem Latein am Ende ist, sollte Spanisch lernen',
        'Die Eselsbrücke ist die ideale Verbindung zwischen zwei Gedächtnislücken.',
        'Kopieren geht über studieren.',
        'Lehrersprüche: Ich habe einen Tinnitus im Auge. Ich sehe überall nur Pfeifen!',
        'Lehrersprüche: Gratuliere! So früh wie heute bist du noch nie zu spät gekommen!',
        'Lehrersprüche: Besser kann ich es nicht erklären. Nur lauter.',
        'Mathematiker stehen nachts auf und müssen [Pi] [Pi]',
        'Wenn ich noch mehr Kaffee trinke, heißt meine Blutgruppe bald Arabica.'
    ];

    let counter = 0;
    const currentHtml = element.innerHTML;
    let interval: NodeJS.Timer | null = null;
    let textChangeInterval: NodeJS.Timer | null = null;
    let text = '';
    let id = '';

    function addText() {
        if (extraData?.noText) {
            return;
        }

        text = list[counter++];
        const template = `<div id="${id}">${text}</div>`;

        element.insertAdjacentHTML('afterend', DOMPurify.sanitize(template));
    }

    if (session.isLoggedIn() || extraData.canDownload) {
        if (interval) {
            return;
        }
        element.setAttribute('disabled', 'disabled');

        id = `material_download_${materialId}`;
        setTimeout(addText);

        element.innerHTML = `<div style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%">
            <img width="20" src="${SpinnerGif}" style="width: 20px; margin-right: 10px" alt="SpinnerGif">
            <span>Warte bitte kurz...</span></div>`;

        textChangeInterval = setInterval(() => {
            setTimeout(() => {
                const waitingBlock = document.getElementById(id);

                if (waitingBlock) {
                    waitingBlock.remove();
                }
                addText();

                if (counter === list.length - 1) {
                    counter = 0;
                }
            });
        }, 5000);

        interval = setInterval(() => {
            setTimeout(() => {
                const isStarted = cookiesManager.getItem(id);

                if (isStarted) {
                    clearInterval(<NodeJS.Timeout>textChangeInterval);
                    clearInterval(<NodeJS.Timeout>interval);
                    interval = null;
                    const el = document.getElementById(id);

                    if (el) {
                        el.remove();
                    }
                    cookiesManager.removeItem(id);
                    element.innerHTML = DOMPurify.sanitize(currentHtml);
                    element.removeAttribute('disabled');

                    if (cb) {
                        cb();
                    }
                }
            });
        }, 100);
    }
};

export default downloading;
